export const LOAD_DATA = 'LOAD_DATA';
export const LOGGED_IN = 'LOGGED_IN';
export const LOGGED_OUT = 'LOGGED_OUT';

export const NEW_POLL = 'NEW_POLL';
export const SAVE_POLL = 'SAVE_POLL';
